import { Routes, Route } from "react-router-dom";
import "./styles/typography.css";
import "./styles/ui-premium.css";
import React, { useEffect } from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

import LayoutHeader from "./components/layout/Layout";
import Home from "./pages/home";
import About from "./pages/aboutUs";
import HowTobuy from "./pages/howTobuy";
import HowToSell from "./pages/howTosale";
import Faq from "./pages/Faq";

import Login from "./pages/Login";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import UpcommingAuctions from "./pages/upcommingAuction";

import useMediaQuery from "@mui/material/useMediaQuery";

import AuctionsViewOnly from "./view/viewingOnly/monitoring";
import Presentation from "./view/viewingOnly/presentation";

import AuctionsRoom from "./view/auctionsRoom/auctions";
import Declarator from "./view/declarator/console";
import Profile from "./view/profile";

import MyFavorite from "./view/Account/myfavorite";

import Mylots from "./view/Account/mylots";

import SuccessPagePayment from "./view/Account/success";

import CancelPagePayment from "./view/Account/cancel";

import Account from "./view/Account/profile";

import Room from "./view/Account/SidebarMenu";

import LotView from "./pages/Lot";

import SearchLot from "./pages/SearchLot";

import PrivateSalesAndExhibition from "./pages/PrivateSell";

import SinglePageProduct from "./pages/SinglePageProduct";

import SinglePrivate from "./pages/SInglePrivateProduct";
import Exhibition from "./pages/Exhibtion";
import ExhibitionPage from "./pages/ExhibtionPage";

import LeonGalleryMain from "./pages/Location/main";
import LeonGalleryInternational from "./pages/Location/international";
import LeonGalleryLafuerza from "./pages/Location/lafuerza";
import LeonGalleryMaison from "./pages/Location/maison";

import BlogSingle from "./pages/Blog-single";
import Blog from "./pages/Blog";
import RequestEstimate from "./pages/requestEstimate";
import SignIn from "./pages/Signup";
import EmailVerify from "./pages/Signup/EmailVerificationPage";

import ForgotPassword from "./pages/Login/ForgotPassword";
import VerifyTokenPage from "./pages/Login/VerifyTokenPage";
import SuccessPage from "./pages/Login/SuccessPage";
import ChatSupportPage from "./view/chatSupportPage/ChatSupportPage";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsPage from "./TermsPage";
import { LegacyRedirect } from "./routes/LegacyRedirect";
import { publicUrls } from "./routes/publicUrls";
import NotificationPrompt from "./components/Notifications/NotificationPrompt";
function App({}) {
  ///useMediaQuery("(min-width:900px)");
  const phoneMatch = useMediaQuery("(min-width:900px)");
  const matches = { phoneMatch };

  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    var counter = 0;

    var timer = setInterval(function () {
      if (navigator.onLine) {
        setLoading(false);
      } else {
        setLoading(true);

        if (counter === 2) {
          alert("No Internet Connection!..");
          setLoading(true);
          clearInterval(timer);
        }
      }

      counter++;
    }, navigator.onLine === true ? 1000 : 9000);

    window.addEventListener("offline", () => {
      setLoading(true);
    });

    window.addEventListener("online", () => {
      clearInterval(timer);
      setLoading(false);
    });
  }, [loading]);

  // console.log("token app: ", token);

  return (
    <>
    <NotificationPrompt />
      <Backdrop
        sx={{
          color: "#1c1c1c",
          background: "#f3f1eb",
          zIndex: (theme) => theme.zIndex.drawer + 999,
        }}
        open={loading}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 3,
          }}
        >
          <Box
            component="img"
            src="/static/media/dddd.f96bbcbee8c8c2f5e3ee.png"
            alt="Leon Gallery"
            title="Leon Gallery"
            sx={{
              width: {
                xs: 150,
                sm: 180,
                md: 210,
              },
              height: "auto",
              display: "block",
              objectFit: "contain",
            }}
          />

          <CircularProgress
            size={36}
            thickness={2}
            sx={{
              color: "#1c1c1c",
            }}
          />
        </Box>
      </Backdrop>

      <div
        style={{
          visibility: loading === true ? "hidden" : "visible",
        }}
      >
        <Routes>
          <Route
            path="/auctions/presentation"
            element={<Presentation mediadQuery={matches} />}
          />

          <Route
            path="/auctions/view/only"
            element={<AuctionsViewOnly mediadQuery={matches} />}
          />

          <Route element={<LayoutHeader elementFoorer={false} />}>
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-to-buy" element={<HowTobuy />} />
            <Route path="/how-to-sell" element={<HowToSell />} />

            <Route path="/request" element={<RequestEstimate />} />

            <Route path="/auctions" element={<UpcommingAuctions />} />

            <Route
              path="/auction/:slug/:id"
              element={<LotView />}
            />

            <Route
              path="/auction/:slug/:id/lot/:lotNo/:title?"
              element={<SinglePageProduct />}
            />

            <Route
              path="/auctions/:slug/:id/:lotNo"
              element={
                <LegacyRedirect
                  build={({ slug, id, lotNo }, location) =>
                    publicUrls.lot(
                      slug,
                      id,
                      lotNo,
                      new URLSearchParams(location.search).get("title") || ""
                    )
                  }
                />
              }
            />

            <Route
              path="/auctions/:slug/:id"
              element={
                <LegacyRedirect
                  build={({ slug, id }) =>
                    publicUrls.auction(slug, id)
                  }
                />
              }
            />

            <Route path="/contact" element={<Contact />} />

            <Route
              path="/contact-us"
              element={
                <LegacyRedirect
                  build={() => publicUrls.contact()}
                />
              }
            />

            <Route
              path="/search/:searching?"
              element={<SearchLot />}
            />

            <Route
              path="/private-sales"
              element={<PrivateSalesAndExhibition />}
            />

            <Route
              path="/private/sale"
              element={
                <LegacyRedirect
                  build={() => publicUrls.privateSales()}
                />
              }
            />

            <Route
              path="/private-sales/:group/:id/:title?"
              element={<SinglePrivate />}
            />

            <Route
              path="/private/:group/:id"
              element={
                <LegacyRedirect
                  build={({ group, id }, location) =>
                    publicUrls.privateSale(
                      group,
                      id,
                      new URLSearchParams(location.search).get("title") || ""
                    )
                  }
                />
              }
            />

            <Route
              path="/private_sales"
              element={
                <LegacyRedirect
                  build={() => publicUrls.privateSales()}
                />
              }
            />

            <Route path="/stories" element={<Blog />} />

            <Route
              path="/stories/:slug?"
              element={<BlogSingle />}
            />

            <Route
              path="/exhibitions/:slug/:id"
              element={<Exhibition />}
            />

            <Route
              path="/exhibitions"
              element={<ExhibitionPage />}
            />

            <Route
              path="/exhibition/:slug/:id"
              element={
                <LegacyRedirect
                  build={({ slug, id }) =>
                    publicUrls.exhibition(slug, id)
                  }
                />
              }
            />

            <Route
              path="/exhibition"
              element={
                <LegacyRedirect
                  build={() => publicUrls.exhibitions()}
                />
              }
            />

            <Route
              path="/locations/international"
              element={<LeonGalleryInternational />}
            />

            <Route
              path="/location/international"
              element={
                <LegacyRedirect
                  build={() =>
                    publicUrls.location("international")
                  }
                />
              }
            />

            <Route
              path="/locations/lafuerza"
              element={<LeonGalleryLafuerza />}
            />

            <Route
              path="/location/lafuerza"
              element={
                <LegacyRedirect
                  build={() =>
                    publicUrls.location("lafuerza")
                  }
                />
              }
            />

            <Route
              path="/locations/main"
              element={<LeonGalleryMain />}
            />

            <Route
              path="/location/main"
              element={
                <LegacyRedirect
                  build={() =>
                    publicUrls.location("main")
                  }
                />
              }
            />

            <Route
              path="/locations/maison"
              element={<LeonGalleryMaison />}
            />

            <Route
              path="/location/maison"
              element={
                <LegacyRedirect
                  build={() =>
                    publicUrls.location("maison")
                  }
                />
              }
            />

            <Route
              path="/my/account"
              element={<Room />}
            />

            <Route path="/faq" element={<Faq />} />

            <Route
              path="/privacy"
              element={<PrivacyPolicy />}
            />

            <Route
              path="/terms-and-conditions"
              element={<TermsPage />}
            />

            <Route path="/" element={<Home />} />

            <Route
              path="*"
              element={<NotFound />}
            />

            <Route
              path="/login"
              element={<Login />}
            />

            <Route
              path="/signup"
              element={<SignIn />}
            />

            <Route
              path="/Signup"
              element={
                <LegacyRedirect
                  build={() => publicUrls.signup()}
                />
              }
            />

            <Route
              path="/verify-account/:token"
              element={<EmailVerify />}
            />

            <Route
              path="/home"
              element={<Home mediadQuery={matches} />}
            />

            <Route
              path="/profile"
              element={<Profile />}
              mediadQuery={matches}
            />

            <Route
              path="/declarator/room"
              element={<Declarator />}
            />

            <Route
              path="/forgot-password"
              element={<ForgotPassword />}
            />

            <Route
              path="/forgot/password"
              element={
                <LegacyRedirect
                  build={() =>
                    publicUrls.forgotPassword()
                  }
                />
              }
            />

            <Route
              path="/reset-password/:token"
              element={<VerifyTokenPage />}
            />

            <Route
              path="/reset-success"
              element={<SuccessPage />}
            />

            <Route
              path="/account"
              element={<Account />}
            />

            <Route
              path="/account/favorites"
              element={<MyFavorite />}
            />

            <Route
              path="/myfavorite"
              element={
                <LegacyRedirect
                  build={() =>
                    publicUrls.favorites()
                  }
                />
              }
            />

            <Route
              path="/account/lots"
              element={<Mylots />}
            />

            <Route
              path="/mylots"
              element={
                <LegacyRedirect
                  build={() =>
                    publicUrls.lots()
                  }
                />
              }
            />

            <Route
              path="/payment/success"
              element={<SuccessPagePayment />}
            />

            <Route
              path="/payment/cancel"
              element={<CancelPagePayment />}
            />

            <Route
              path="/auction-room"
              element={
                <AuctionsRoom
                  mediadQuery={matches}
                />
              }
            />

            <Route
              path="/auctions/room"
              element={
                <LegacyRedirect
                  build={() =>
                    publicUrls.auctionRoom()
                  }
                />
              }
            />
          </Route>

          <Route
            path="/chat/support/:auctionID"
            element={
              <ChatSupportPage
                mediadQuery={matches}
              />
            }
          />
        </Routes>
      </div>
    </>
  );
}



export default App;